import { Fragment, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const METRICS = [["races", "Races", null], ["top_win_pct", "Top pick wins", "top_wins"], ["top_place_pct", "Top pick places", "top_places"],
  ["top3_win_pct", "Winner in top 3", "top3_wins"], ["top3_place_pct", "Top 3 placed", "top3_places"], ["top3_win_avg_sp", "Avg winner SP", null]];
const GROUPS = [["all", "All rain-affected (6–10)"], ["slow", "Slow (6–7)"], ["heavy", "Heavy (8–10)"]];

const val = (s, k, n) => (k === "races" ? s.races : k === "top3_win_avg_sp" ? (s[k] != null ? `$${s[k].toFixed(2)}` : "—") : `${s[k]}%${n ? ` (${s[n]})` : ""}`);
const diffCls = (a, b, k) => (["races", "top3_win_avg_sp"].includes(k) || a[k] == null || b[k] == null || a[k] === b[k] ? "text-white" : a[k] > b[k] ? "text-emerald-300" : "text-rose-300");

const Compare = ({ g, label, id }) => (
  <div className="panel p-5" data-testid={`impact-group-${id}`}>
    <div className="eyebrow mb-3">{label}</div>
    <table className="w-full text-sm num">
      <thead><tr className="text-slate-500 text-xs text-left"><th className="py-1 font-normal" /><th className="py-1 font-normal text-right">Slow + Heavy</th><th className="py-1 font-normal text-right">Old Wet</th></tr></thead>
      <tbody>{METRICS.map(([k, l, n]) => (
        <tr key={k} className="border-t border-slate-800/60">
          <td className="py-1.5 text-slate-400 font-sans">{l}</td>
          <td className={`py-1.5 text-right ${diffCls(g.new, g.old, k)}`} data-testid={`impact-${id}-new-${k}`}>{val(g.new, k, n)}</td>
          <td className="py-1.5 text-right text-slate-300" data-testid={`impact-${id}-old-${k}`}>{val(g.old, k, n)}</td>
        </tr>))}
      </tbody>
    </table>
  </div>
);

const Top3 = ({ list }) => list.map((h) => (
  <span key={h.number} className={`mr-2 whitespace-nowrap ${h.finish === 1 ? "text-emerald-300 font-bold" : h.finish && h.finish <= 3 ? "text-amber-300" : "text-slate-300"}`}>{h.number} {h.name}</span>
));

export default function MatrixImpact() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/matrix-impact").then((r) => setData(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);
  return (
    <div className="space-y-6">
      <div className="fade-up">
        <div className="eyebrow mb-2">Admin • rain-affected tracks</div>
        <h1 className="text-4xl sm:text-5xl font-bold" data-testid="impact-title">Matrix Impact Check</h1>
        <p className="text-sm text-slate-400 mt-3 max-w-3xl">Past races with results on tracks rated 6–10, rated twice: with the new Slow + Heavy matrices (places) and with the old Wet Track matrix (wins). Green = the new scoring did better.</p>
      </div>
      {!data ? <div className="py-12 grid place-items-center"><div className="loader-bar" /></div> : (
        <>
          <div className="grid lg:grid-cols-3 gap-4">{GROUPS.map(([id, l]) => <Compare key={id} id={id} label={l} g={data.groups[id]} />)}</div>
          <div className="panel overflow-x-auto" data-testid="impact-changed">
            <div className="eyebrow p-5 pb-3">Races where the top 3 changed • {data.changed_count}</div>
            {!data.changed.length ? <p className="px-5 pb-5 text-sm text-slate-400">No differences yet.</p> : (
              <table className="w-full text-xs">
                <thead><tr className="text-slate-500 text-left border-b border-slate-800">{["Race", "Track", "Winner", "Slow + Heavy top 3", "Old Wet top 3"].map((h) => <th key={h} className="px-5 py-2 font-normal">{h}</th>)}</tr></thead>
                <tbody>{data.changed.map((c, i) => (
                  <Fragment key={c.id}>
                    <tr className="border-b border-slate-800/60" data-testid={`impact-changed-row-${i}`}>
                      <td className="px-5 py-2 whitespace-nowrap text-white">{c.date} • {c.venue} R{c.race_number}</td>
                      <td className="px-5 py-2 whitespace-nowrap text-slate-300">{c.track}</td>
                      <td className="px-5 py-2 whitespace-nowrap text-slate-300">{c.winner || "—"}</td>
                      <td className="px-5 py-2"><Top3 list={c.new_top3} /></td>
                      <td className="px-5 py-2"><Top3 list={c.old_top3} /></td>
                    </tr>
                  </Fragment>))}
                </tbody>
              </table>)}
          </div>
        </>
      )}
    </div>
  );
}
